module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_08_sp-3b9949f9df8c78f4bb48f42b32456942.png";